/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_DescriptionInputs */

const es_admin_users_description = /** @type {(inputs: Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestioná los usuarios que forman parte de tu empresa en Nexata.`)
};

const en_admin_users_description = /** @type {(inputs: Admin_Users_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the users that belong to your Nexata organization.`)
};

/**
* | output |
* | --- |
* | "Manage the users that belong to your Nexata organization." |
*
* @param {Admin_Users_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_description = /** @type {((inputs?: Admin_Users_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_description(inputs)
	return en_admin_users_description(inputs)
});
export { admin_users_description as "admin.users.description" }